<twc-wizard #wizard [caption]="uploadWizardService.wizardTitle | translate" class="project-wizard">
    <twc-wizard-steps class="height-100">
        <twc-wizard-step [label]="'WIZARD.TAB_FILES' | translate">
            {{extraPanel.panelName}}
            <cw-create-wizard-input-data *ngIf="uploadWizardService.showWizard"
                [subtitle]="uploadWizardService.wizardSubtitle"
                (optionalStep)="updateExtraSteps($event)"></cw-create-wizard-input-data>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_NEW_PROJECT' | translate"
            *ngIf="uploadWizardService.showWizard && uploadWizardService.importType === 'project'">
            <cw-create-project-wizard-project-data>
            </cw-create-project-wizard-project-data>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_OUTPUT_LAYER' | translate"
            *ngIf="uploadWizardService.showWizard && uploadWizardService.importType === 'layer'">
            <cw-select-layer></cw-select-layer>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_DESTINATION_GROUP' | translate"
            *ngIf="uploadWizardService.showWizard && hasToShowDestinationGroupStep()">
            <cw-workspace-options [subtitle]="uploadWizardService.wizardSubtitle" (nameChange)="onNameChanged($event)">
            </cw-workspace-options>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_CONVERT_POINTCLOUD' | translate"
            *ngIf="uploadWizardService.showWizard && extraPanel.panelName === wizardPanelTypes.POINTCLOUD_CONFIGURATION">
            <cw-pointcloud-import-options
                [subtitle]="uploadWizardService.wizardSubtitle">></cw-pointcloud-import-options>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_UAV_CONFIGURATION' | translate"
            *ngIf="uploadWizardService.showWizard && extraPanel.panelName === wizardPanelTypes.UAV_CONFIGURATION">
            <cw-uav-import-options></cw-uav-import-options>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_CONVERT_OBJ_MODEL3D' | translate"
            *ngIf="uploadWizardService.showWizard && extraPanel.panelName === wizardPanelTypes.OBJ_MODEL_3D_CONVERTER_CONFIGURATION">
            <cw-3d-model-import-options [subtitle]="uploadWizardService.wizardSubtitle"></cw-3d-model-import-options>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_GIS_IMPORTER' | translate"
            *ngIf="uploadWizardService.showWizard && extraPanel.panelName === wizardPanelTypes.GIS_IMPORTER_CONFIGURATION">
            <cw-gis-import-options></cw-gis-import-options>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_CRP1_SCAN_SELECTOR' | translate"
            *ngIf="uploadWizardService.showWizard && hasToShowCRP1SelectScans()">
            <cw-crp1-scan-select></cw-crp1-scan-select>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_SCAN_PROCESSING' | translate"
            *ngIf="uploadWizardService.showWizard && hasToShowScanProcessingStep()">
            <cw-scan-processing-options [subtitle]="uploadWizardService.wizardSubtitle"
                (creditsNotEstimate)="uploadWizardService.onCreditsCanBeEstimated($event)"
                [isDisabledColorizeAndPanorama]="uploadWizardService.importType === 'CreateStation'">
            </cw-scan-processing-options>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_POINT_SELECTOR' | translate"
            *ngIf="uploadWizardService.showWizard && hasToShowPointSelectorStep()">
            <cw-point-selector [subtitle]="uploadWizardService.wizardSubtitle"></cw-point-selector>
        </twc-wizard-step>

        <twc-wizard-step [label]="'WIZARD.TAB_SUMMARY' | translate" cwHideStepIcon>
            <cw-create-wizard-summary [subtitle]="uploadWizardService.wizardSubtitle"
                [showEstimationMessage]="uploadWizardService.canEstimateCredits"
                *ngIf="uploadWizardService.showWizard"></cw-create-wizard-summary>
        </twc-wizard-step>
    </twc-wizard-steps>

    <twc-wizard-footer>
        <button class="twc-button twc-button-link" *ngIf="isPrevButtonVisible" (click)="onPrevButtonClick()"
            [disabled]="isFirstStep || isUploadStarted">
            {{'WIZARD.PREVIOUS' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="isNextButtonVisible" (click)="onNextButtonClick()"
            [disabled]="!isNextButtonEnabled">
            {{'WIZARD.NEXT' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="isUploadButtonVisible" (click)="onUploadButtonClick()">
            {{'WIZARD.UPLOAD_AND_PROCESS' | translate}}
        </button>
        <button class="twc-button twc-button-primary"
            *ngIf="isCloseButtonVisible && !workflowWizardService.isWorkflowUploading" (click)="onCloseButtonClick()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="workflowWizardService.isWorkflowUploading" disabled>
            <twc-loader size="tiny"></twc-loader>
        </button>
    </twc-wizard-footer>
</twc-wizard>